












































import { Component, Vue, Watch } from "vue-property-decorator";
import ArtShowcase from "../ArtShowcase.vue";
import { firestore } from "../../firebaseInit";
import { collection, getDocs } from "firebase/firestore";
import { Art, byNewestFirst } from "../../models/Art";

@Component({
  components: {
    ArtShowcase,
  },
})
export default class Reproductions extends Vue {
  private artArray: any[] = [];
  private categoryArtArray: any[] = [];
  private loaded = false;
  private reproductionType: 'card' | 'print' = 'print'

  async created() {
    const imagesRef = collection(firestore, "reproductions");
    const collectionSnap = await getDocs(imagesRef);

    let artArray: Art[] = [];
    collectionSnap.forEach((doc) => {
      let art = { ...doc.data(), id: doc.id } as Art;
      if (art.isActive !== false) artArray.push(art as Art);
    });

    this.artArray = artArray.sort(byNewestFirst);
    this.categoryArtArray = this.artArray.filter(art => art.reproductionType == this.reproductionType);
    this.loaded = true;
  }

  @Watch('reproductionType')
  handleReproductionTypeChange() {
    this.categoryArtArray = this.artArray.filter(art => art.reproductionType == this.reproductionType);
  }
}
